<template>
  <div class="container">
    <div class="title">{{ $t('doc.camera_query_title') }}</div>
    <div class="content main" v-for="(item, index) in info" :key="item.title">
      <template v-if="!item.tableData">
        <div class="listTitle">{{ item.title }}</div>
        <div :style="{ color: index == 1 ? '#0077FF' : '' }">
          {{ item.content }}
        </div>
      </template>
      <template v-else>
        <div class="listTitle">
          {{ item.title }}
        </div>
        <div class="table">
          <el-table
            :data="item.tableData"
            :header-cell-style="{
              backgroundColor: '#0077FF',
              color: '#FFF',
              fontWeight: '500',
            }"
          >
            <el-table-column
              v-for="(column, index) in item.tableKey"
              :key="column"
              :prop="column"
              :label="item.tableName[index]"
            >
            </el-table-column>
            <!-- <el-table-column prop="tips" label="提示"> </el-table-column> -->
          </el-table>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "OpenWebInfoSearch",

  data() {
    return {};
  },
  computed: {
    // info 转 computed：文档文案随语言热切换
    info() {
      const key = ["name", "type", "require", "example", "describe"];
      const col = [this.$t("doc.col_name"), this.$t("doc.col_type"), this.$t("doc.col_require"), this.$t("doc.col_example"), this.$t("doc.col_describe")];
      return [
        { title: this.$t("doc.s_desc"), content: this.$t("doc.camera_query_desc") },
        { title: this.$t("doc.s_addr"), content: this.$t("doc.addr_camera") },
        { title: this.$t("doc.s_auth"), content: "token" },
        { title: this.$t("doc.s_req_type"), content: "get" },
        {
          title: this.$t("doc.s_req_header"), content: "",
          tableData: [
            { name: "Authorization", type: "string", require: "Y", example: this.$t("doc.e_bearer"), describe: this.$t("doc.d_token_auth") },
          ],
          tableKey: key, tableName: col,
        },
        {
          title: this.$t("doc.s_req_param6"), content: "",
          tableData: [
            { name: "sn", type: "string", require: "N", example: "", describe: this.$t("doc.d_sn") },
            { name: "name", type: "string", require: "N", example: "", describe: this.$t("doc.d_name") },
            { name: "cardCode", type: "string", require: "N", example: "", describe: this.$t("doc.d_cardcode") },
            { name: "onlion", type: "string", require: "N", example: "", describe: this.$t("doc.d_online") },
            { name: "limit", type: "int", require: "Y", example: "", describe: this.$t("doc.d_limit") },
            { name: "page", type: "int", require: "Y", example: "", describe: this.$t("doc.d_page") },
          ],
          tableKey: key, tableName: col,
        },
        {
          title: this.$t("doc.s_return_param"), content: "",
          tableData: [
            { name: "code", type: "string", require: "Y", example: "200", describe: this.$t("doc.d_code") },
            { name: "msg", type: "string", require: "Y", example: this.$t("doc.e_success"), describe: this.$t("doc.d_msg") },
            { name: "data", type: "object", require: "", example: "", describe: "" },
          ],
          tableKey: key, tableName: col,
        },
        {
          title: this.$t("doc.s_data8"), content: "",
          tableData: [
            { name: "limit", type: "int", require: "Y", example: "", describe: this.$t("doc.d_limit") },
            { name: "page", type: "int", require: "Y", example: "", describe: this.$t("doc.d_page") },
            { name: "list", type: "array", require: "Y", example: "", describe: this.$t("doc.d_list") },
            { name: "total", type: "int", require: "Y", example: "", describe: this.$t("doc.d_total") },
          ],
          tableKey: key, tableName: col,
        },
        {
          title: this.$t("doc.s_list"), content: "",
          tableData: [
            { name: "sn", type: "string", require: "N", example: "", describe: this.$t("doc.d_camera_sn") },
            { name: "name", type: "string", require: "N", example: "", describe: this.$t("doc.d_name") },
            { name: "cardCode", type: "string", require: "N", example: "", describe: this.$t("doc.d_card_inner") },
            { name: "channel", type: "string", require: "N", example: "", describe: this.$t("doc.d_channel") },
            { name: "freq", type: "int", require: "N", example: "", describe: this.$t("doc.d_freq") },
          ],
          tableKey: key, tableName: col,
        },
      ];
    },
  },

  mounted() {},

  methods: {},
};
</script>
<style lang="scss" scoped>
.title {
  padding: 10px 0;
  font-size: 24px;
  font-weight: 500;
}
.listTitle {
  font-weight: 500;
}
.main > div {
  margin: 20px 0;
  // background-color: red;
}
.table {
  width: 75%;
}
.main:last-child {
  padding-bottom: 100px;
}
</style>